import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  pillButtonBase,
  pillButtonTone,
  pillBadgeClass,
} from "./navPillStyles";

/**
 * Top-bar pill icon button used inside a NavPillGroup. Renders a Link when `to`
 * is given, otherwise a button wired to `onClick`. Supports an optional numeric
 * badge (`count`) or a small "unseen" dot.
 */
const NavPillButton = ({
  title,
  to,
  onClick,
  count = 0,
  dot = false,
  icon,
  isDark,
}) => {
  const badge =
    count > 0 ? (
      <span className={pillBadgeClass(isDark)}>
        {count > 99 ? "99+" : count}
      </span>
    ) : dot ? (
      <span
        className={`absolute top-1.5 end-1.5 w-2 h-2 rounded-full bg-warning border-2 ${
          isDark ? "border-chrome" : "border-surface-muted"
        }`}
        aria-hidden="true"
      />
    ) : null;

  const inner = (
    <>
      <FontAwesomeIcon icon={icon} className="text-[18px]" />
      {badge}
    </>
  );

  const className = `${pillButtonBase} ${pillButtonTone(isDark)}`;

  return (
    <Tooltip title={title}>
      {to ? (
        <Link to={to} className={className}>
          {inner}
        </Link>
      ) : (
        <button type="button" onClick={onClick} className={className}>
          {inner}
        </button>
      )}
    </Tooltip>
  );
};

export default NavPillButton;
